import React from 'react';

import { useFormikContext } from 'formik';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from 'revibe-ui';

import { useMediaQuery } from 'modules/common/hooks';
import { useCategories } from 'modules/item/hooks/useCategories';
import { ITEM_FILTERS } from 'modules/item/utils/itemFilter';
import { MarketplaceAPI } from 'revibe-api';
import { useTranslation } from 'i18n/hooks';

export const CategoryFilter = () => {
  const { isMobile } = useMediaQuery();
  const { values, setFieldValue, handleSubmit } =
    useFormikContext<MarketplaceAPI.ItemFilters>();
  const { tu } = useTranslation('shop.categories');
  const { categories } = useCategories();

  return (
    <Select
      value={values[ITEM_FILTERS.CATEGORY] || 'all'}
      onValueChange={(selectedOption) => {
        setFieldValue(
          ITEM_FILTERS.CATEGORY,
          selectedOption === 'all' ? undefined : selectedOption
        );
        !isMobile && handleSubmit();
      }}
    >
      <SelectTrigger className="bg-gray-50 text-xs font-light uppercase">
        <SelectValue placeholder="Select a category" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem className="text-xs font-light uppercase" value="all">
          {tu('all')}
        </SelectItem>
        <SelectSeparator />
        {categories.map((category) => (
          <SelectItem
            className="text-xs font-light uppercase"
            value={String(category.slug)}
          >
            {category.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
